// Shared by useSaveDraft/useSendDraft: a DRAFT_VERSION_CONFLICT response must reach
// useSmartDraftManager as a distinguishable result, never as `null` — `null` reads as
// "no data returned" (see NO_SAVE_DATA) and gets treated as a generic failure instead of
// "someone else changed this draft, do not overwrite it".
export interface DraftConflictResult {
  isDraftConflict: true;
  currentDraftVersion?: string;
}

export const isDraftConflictResult = (
  value: unknown,
): value is DraftConflictResult =>
  Boolean(value) &&
  typeof value === 'object' &&
  (value as Partial<DraftConflictResult>).isDraftConflict === true;
